import React from 'react';
import { Container, Row, Col, Card, Form, Button, Breadcrumb } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TimerAlert, ConfirmAlert, InforAlert } from '../../utils/swtAlert';
import { GrokLoading } from '../page-layout/loading/Loading';
import { Decrypt } from '../../utils/Helper';
import { GetLookUps } from '../../utils/axios/LookUpAPI';
import { UpdateEnrollUser, UpdatEnrolledeUser } from '../../utils/axios/EnrollUserAPI';
import { GetBusinessChallenges } from '../../utils/axios/ChallengesAPI';
import { GetColleges, GetOrganization } from '../../utils/axios/CompanyAPI';
import { GetSelectedBranches } from '../../utils/axios/LookUpAPI';
import { ORGANIZATION_TYPE } from "../constants/constants";

function NewEnrollUserDetail() {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const location = useLocation();
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    //Form Control Variables Starts..
    const [email, setEmail] = useState('');
    const [ContactNumber, setContactNumber] = useState('');
    const [isCollege, setIsCollege] = useState(false);
    const [numberError, setNumberError] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [college, setCollege] = useState("others");
    const [collegeslist, setCollegesList] = useState([]);
    const [branch, setBranch] = useState("");
    const [branchlist, setBranchlist] = useState([]);
    const [year, setYear] = useState("");
    const [yearlist, setYearlist] = useState([]);
    const [semester, setSemester] = useState("");
    const [semesterlist, setSemesterlist] = useState([]);
    const [Gender, setGender] = useState("");
    const [challengeTitle, setChallengeTitle] = useState('');
    const [Course, setCourse] = useState("");
    const [genterlist, setGenderList] = useState([]);
    const [courseList, setCourseList] = useState([]);
    //Form Control Variables Ends..

    const handleSubmit = (event) => {
        if (event && event.preventDefault) {
            event.preventDefault();
            const form = event.currentTarget;

            if (form && form.checkValidity && form.checkValidity() === false) {
                event.stopPropagation();
                setValidated(true);
                return;
            }
           else if(college === "others") {
                InforAlert("Enroll failed", 'Please, Select the relevant Associate College', 'warning', 'OK');
                return;
            }
            saveEnrollUser();
        }
    }

    const BackBtn = () => {
        navigate('/newenrollusers', { state: { userid: null } });
    }

    const getHomeChallenges = async () => {
        setLoading(true);
        var challengesResponse = await GetBusinessChallenges();
        setData(challengesResponse.data);
        setLoading(false);
    }

    const bindFormPreloadData = async () => {
        setLoading(true);
        //Getting Semester List from Lookup
        let semesterpayload = {
            Type: 6
        }
        var semesterResponse = await GetLookUps(semesterpayload);
        setSemesterlist(semesterResponse.data);

        let branchPayload = {
            Type: 7
        }
        var branchResponse = await GetLookUps(branchPayload);
        setBranchlist(branchResponse.data);

        //Getting Year List from Lookup
        let yearpayload = {
            Type: 2
        }
        var yearResponse = await GetLookUps(yearpayload);
        setYearlist(yearResponse.data);

        var clgResponse = await GetColleges();
        setCollegesList(clgResponse.data);
        setLoading(false);
        let organizationPayload = {
            OrganizationType: ORGANIZATION_TYPE.COLLEGE,
            // isGrovator: groktype
        }
        var organinizationResponse = await GetOrganization(organizationPayload);
        setCollegesList(organinizationResponse.data);

        let genderpayload = {
            Type: 1
        }
        var genderResponse = await GetLookUps(genderpayload);
        setGenderList(genderResponse.data);
    }

    const saveEnrollUser = async () => {
        let userPayload = {
            ChallengeId: challengeTitle,
            OrganizationId: college,
            FirstName: firstName,
            LastName: lastName,
            Gender: Gender,
            Branch: branch,
            Year: year,
            Semester: semester,
            Email: email,
            ContactNumber: ContactNumber,
            UpdatedBy: userInfo._id
        }
        if (location.state.studentid != null || location.state.tempUserId != null) {
            var id = location.state.studentid ? location.state.studentid : location.state.tempUserId;
            var response = await UpdatEnrolledeUser(id, userPayload);
            if (response.message) {
                TimerAlert('Enroll New User Update Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'Enroll new User Updated Successfully', 'success');
                setTimeout(() => navigate("/newenrollusers"), delay);
            }
        }
    }

    const bindFormData = async () => {
        if (location.state.studentid != null) {
            var response = await UpdateEnrollUser(location.state.studentid);
            if (response) {
                setIsCollege(response.data.OrganizationName);
                setLastName(response.data.LastName);
                setFirstName(response.data.FirstName);
                setContactNumber(response.data.ContactNumber);
                setEmail(response.data.Email);
                setBranch(response.data.Branch.id);
                setYear(response.data.Year.id);
                setSemester(response.data.Semester.id);
                setGender(response.data.Gender.id);
                setChallengeTitle(response.data.ChallengeId.Id);
            }
        }
        setLoading(false);
    };

    const bindNotificationData = async () => {
        if (location.state.tempUserId != null) {
            var response = await UpdateEnrollUser(location.state.tempUserId);
            if (response) {
                setIsCollege(response.data.OrganizationName)
                setLastName(response.data.LastName);
                setFirstName(response.data.FirstName);
                setContactNumber(response.data.ContactNumber);
                setEmail(response.data.Email);
                setBranch(response.data.Branch.id);
                setYear(response.data.Year.id);
                setSemester(response.data.Semester.id);
                setGender(response.data.Gender.id);
                setChallengeTitle(response.data.ChallengeId.Id)
            }
        }
        setLoading(false);
    };


    const clearState = () => {
        setIsCollege("");
        setLastName("");
        setFirstName("");
        setEmail("");
        setBranch("");
        setCourse("");
        setContactNumber("");
        setYear('');
        setSemester('');
        setGender('');
        setChallengeTitle('');
    };
    const clear = () => {
        ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
            .then((result) => {
                if (result.isConfirmed) {
                    clearState();
                }
            });
    };
    const addRefresh = () => {
        navigate('/home', { state: { userid: null } });
    }

    const handleUser = () => {
        navigate('/newenrollusers', { state: { userid: null } });
    }

    const collegeChanged = async (e) => {
        const selectedCollege = e.target.value;
        console.log(e.target.value)
        setCollege(selectedCollege);
        if (selectedCollege !== "" && selectedCollege !== "others") {
            let branchesPayload = {
                OrganizationId: e.target.value
            }
            setLoading(true);
            var response = await GetSelectedBranches(branchesPayload);
            setBranchlist(response.data);
            setLoading(false);
        }
        setBranch("");
    };
    useEffect(() => {
        bindFormPreloadData();
        bindFormData();
        bindNotificationData();
        getHomeChallenges();

        setTimeout(() => {
            document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.children[4].classList.add('active');
        }, 300);
    }, [])

    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />

            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item onClick={() => handleUser()}> New Enroll User</Breadcrumb.Item>
                                    <Breadcrumb.Item active>New Enroll User Detail</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col>
                                <h2 className="page-title">Edit Enroll user</h2>
                            </Col>
                            <Col lg={2} className="mb-1" >
                                <Form.Group >
                                    <button className='newBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}

                    <div className='py-3'>
                        <Row className='g-2 justify-content-center'>

                            <Col className='col-lg-10 mb-4'>
                                <Card className='card-hover-shadow'>
                                    <Card.Body>
                                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                            <Row >
                                                <Col lg={12}>
                                                    <Form.Group className="mb-3" >
                                                        <Form.Label> <h4>NewEnrollUser Details</h4> </Form.Label>
                                                    </Form.Group>
                                                </Col><hr />
                                                 <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Industry Use Case<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={challengeTitle} onChange={(e) => setChallengeTitle(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {data.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Title}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Use Case is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >First Name <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" id="FirstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} minLength={3} placeholder="Enter First Name" required />
                                                            <Form.Control.Feedback type="invalid">Invalid FirstName </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Last Name <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" id="LastName" value={lastName} onChange={(e) => setLastName(e.target.value)} minLength={1} placeholder="Enter Last Name" required />
                                                            <Form.Control.Feedback type="invalid">Invalid LastName </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Display Name </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" className='displayname' id="Name" value={firstName + " " + lastName} onChange={(e) => setDisplayName(e.target.value)} readOnly />
                                                            <Form.Control.Feedback type="invalid">Invalid DisplayName </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Gender<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={Gender} onChange={(e) => setGender(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {genterlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">Gender is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Organization Name </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" className='displayname' id="Name" value={isCollege} readOnly />
                                                            <Form.Control.Feedback type="invalid">Invalid Organization </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Associate College<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={college} onChange={(e) => collegeChanged(e)} required >
                                                                <option value={""}>Select</option>
                                                                {collegeslist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                                
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Associate CollegeName is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Branch<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={branch} onChange={(e) => setBranch(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {branchlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Branch is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Year <em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={year} onChange={(e) => setYear(e.target.value)} required >
                                                                <option value={''}>Select</option>
                                                                {yearlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Year is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Semester<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={semester} onChange={(e) => setSemester(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {semesterlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Semester is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label  >Email ID<em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control className="form-group" type="email" id="email" placeholder="Enter your email" required value={email} onChange={(e) => setEmail(e.target.value)} disabled/>
                                                            <Form.Control.Feedback type="invalid">Email is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Label>Contact Number<em className="Required">*</em> </Form.Label>
                                                    <Form.Control type="numeric" minLength={10} maxLength="10" id="ContactNumber" placeholder="Enter Contact Number" required value={ContactNumber} onChange={(e) => setContactNumber(e.target.value)} />
                                                    {numberError && <div style={{ color: 'red' }}>{numberError}</div>}
                                                    <Form.Control.Feedback type="invalid">Contact Number is required </Form.Control.Feedback>
                                                </Col>
                                                <Row className='mt-3'>
                                                    <Col xs={4}>
                                                        <Button variant="danger" type="button" size="sm" aria-label="small button" onClick={() => clear()}> Clear</Button>
                                                    </Col>
                                                    <Col>
                                                        <div className="d-flex gap justify-content-end">
                                                            <Button variant="success" size="sm" aria-label="small button" type="submit"> Save</Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </Container>

                <Footer />
            </div>
        </div>
    )
}
export default NewEnrollUserDetail;